const COLUMN_WIDTH = 8;
const DROP_HEIGHT = 4;
const COLOR_GREEN = 0x00ff41;

interface RainColumn {
  x: number;
  headY: number;
  speed: number;
  trailLength: number;
  maxAlpha: number;
}

function createColumn(
  x: number,
  viewportHeight: number,
  randomizeStart: boolean,
): RainColumn {
  return {
    x,
    headY: randomizeStart
      ? Math.random() * viewportHeight * 2 - viewportHeight
      : -Math.random() * viewportHeight * 0.5,
    speed: 30 + Math.random() * 50,
    trailLength: 6 + Math.floor(Math.random() * 9),
    maxAlpha: 0.3 + Math.random() * 0.5,
  };
}

export class CodeRainRenderer {
  private readonly graphics: Phaser.GameObjects.Graphics;
  private readonly columns: RainColumn[] = [];
  private readonly viewportHeight: number;

  constructor(scene: Phaser.Scene, viewportWidth: number, viewportHeight: number) {
    this.viewportHeight = viewportHeight;

    this.graphics = scene.add.graphics();
    this.graphics.setScrollFactor(0);
    this.graphics.setDepth(0);

    const columnCount = Math.ceil(viewportWidth / COLUMN_WIDTH);
    for (let i = 0; i < columnCount; i += 1) {
      this.columns.push(createColumn(i * COLUMN_WIDTH, viewportHeight, true));
    }
  }

  public update(delta: number): void {
    const deltaSec = delta / 1000;
    for (let i = 0; i < this.columns.length; i += 1) {
      const col = this.columns[i];
      if (col === undefined) continue;

      col.headY += col.speed * deltaSec;

      if (col.headY - col.trailLength * DROP_HEIGHT > this.viewportHeight) {
        this.columns[i] = createColumn(col.x, this.viewportHeight, false);
      }
    }
  }

  public render(): void {
    this.graphics.clear();

    for (const col of this.columns) {
      for (let j = 0; j < col.trailLength; j += 1) {
        const y = col.headY - j * DROP_HEIGHT;
        if (y < -DROP_HEIGHT || y > this.viewportHeight + DROP_HEIGHT) {
          continue;
        }

        const fadeRatio = 1 - j / col.trailLength;
        const alpha = col.maxAlpha * fadeRatio * fadeRatio;

        this.graphics.fillStyle(COLOR_GREEN, alpha);
        this.graphics.fillRect(col.x, y, COLUMN_WIDTH - 1, DROP_HEIGHT - 1);
      }
    }
  }

  public destroy(): void {
    this.graphics.destroy();
  }
}
